var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.8438C14.5469 12.8438 14.8438 12.584 14.8438 12.25V4.67969L12.3203 2.15625H7.125C6.79102 2.15625 6.53125 2.45312 6.53125 2.75V12.25C6.53125 12.584 6.79102 12.8438 7.125 12.8438H14.25ZM7.125 14.625C5.78906 14.625 4.75 13.5859 4.75 12.25V2.75C4.75 1.45117 5.78906 0.375 7.125 0.375H12.3203C12.7656 0.375 13.248 0.597656 13.582 0.931641L16.0684 3.41797C16.4023 3.75195 16.625 4.23438 16.625 4.67969V12.25C16.625 13.5859 15.5488 14.625 14.25 14.625H7.125ZM2.375 5.125H3.5625V6.90625H2.375C2.04102 6.90625 1.78125 7.20312 1.78125 7.5V17C1.78125 17.334 2.04102 17.5938 2.375 17.5938H9.5C9.79688 17.5938 10.0938 17.334 10.0938 17V15.8125H11.875V17C11.875 18.3359 10.7988 19.375 9.5 19.375H2.375C1.03906 19.375 0 18.3359 0 17V7.5C0 6.20117 1.03906 5.125 2.375 5.125Z",
    fill: "#1C5D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9277H16.625V18.8555H0V17.9277Z",
    fill: "#1C5D9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.cd6f26c1d91949ea80802fe4cfe92c16.svg";
export { ForwardRef as ReactComponent };